import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEye, faEyeSlash, fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import Select from "react-select";
import { Select2Data } from "../../../utils/common";
import JoditEditor from "jodit-react";
import { logDOM } from "@testing-library/react";
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/masters/employee/${id}`);
    reset(response?.data);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    trigger,
    setValue,
    watch,
    getValues,
  } = useForm();
 
  const [role, setRole] = useState([]);
  const GetAllRole = async () => {
      const response = await getData("/allrole");
  
      if (response?.success) {
        setRole(await Select2Data(response?.data, "role_id"));
      }
    };
  
    useEffect(() => {
      GetAllRole();
    }, []);

  const [showPasswordCurrent, setShowPasswordCurrent] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordOne, setShowPasswordOne] = useState(false);
    const togglePasswordVisibility = (field) => {
      if (field === "password") {
        setShowPassword(!showPassword);
        setIconOne(showPassword ? faEyeSlash : faEye);
      } else if (field === "reenterPassword") {
        setShowPasswordOne(!showPasswordOne);
        setIconTwo(showPasswordOne ? faEyeSlash : faEye);
      } else if (field === "current_password") {
        setShowPasswordCurrent(!showPasswordCurrent);
        setIconCurrent(showPasswordCurrent ? faEyeSlash : faEye);
      }
    };
    const [password, setPassword] = useState("");
    const [passwordCurrent, setPasswordCurrent] = useState("");
    const [passwordAgain, setPasswordAgain] = useState("");
  
    const [iconOne, setIconOne] = useState(faEyeSlash);
    const [iconTwo, setIconTwo] = useState(faEyeSlash);
    const [iconCurrent, setIconCurrent] = useState(faEyeSlash);

  const onSubmit = async (data) => {
    try {
      console.log(
        data?.fuel_type_id,
        " data?.fuel_type_id  data?.fuel_type_id"
      );

      const DataToSend = new FormData();
      DataToSend.append("image", data?.image[0]);
      DataToSend.append("fuel_type_id", data?.fuel_type_id?.value);
      DataToSend.append("name", data?.name);
      DataToSend.append("facilities", data?.facilities);
      DataToSend.append("included", data?.included);
      DataToSend.append("long_description", data?.long_description);
      DataToSend.append("excluded", data?.excluded);
      DataToSend.append("cancellation", data?.cancellation);
      DataToSend.append("seat_capacity_id", data?.seat_capacity_id?.value);
      DataToSend.append("cab_name", data?.cab_name);
      DataToSend.append("sort_order", data?.sort_order);
      DataToSend.append("driver_payment", data?.driver_payment);
      const response = await postData(`/masters/employee/${id}`, DataToSend);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Employee
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>role</Form.Label>
                    <Controller
                      name="role_id" // name of the field
                      {...register("role_id", {
                        required: "Select Role",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.role_id ? "red" : baseStyles,
                            }),
                          }}
                          {...field}
                          options={role}
                        />
                      )}
                    />
                    {errors.role_id && (
                      <span className="text-danger">
                        {errors.role_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>First Name</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="First Name"
                        className={classNames("", {
                          "is-invalid": errors?.first_name,
                        })}
                        {...register("first_name", {
                          required: "First Name is required",
                        })}
                      />
                    </InputGroup>
                    {errors.first_name && (
                      <span className="text-danger">
                        {errors.first_name.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Last Name</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Last Name"
                        className={classNames("", {
                          "is-invalid": errors?.last_name,
                        })}
                        {...register("last_name", {
                          required: "Last Name is required",
                        })}
                      />
                    </InputGroup>
                    {errors.last_name && (
                      <span className="text-danger">
                        {errors.last_name.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Email</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Email"
                        className={classNames("", {
                          "is-invalid": errors?.email,
                        })}
                        {...register("email", {
                          required: "Email is required",
                        })}
                      />
                    </InputGroup>
                    {errors.email && (
                      <span className="text-danger">
                        {errors.email.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Contact no</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Contact no"
                        className={classNames("", {
                          "is-invalid": errors?.contact_no,
                        })}
                        {...register("contact_no", {
                          required: "Contact no is required",
                        })}
                      />
                    </InputGroup>
                    {errors.contact_no && (
                      <span className="text-danger">
                        {errors.contact_no.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section my-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Password</Form.Label>
                    </div>
                    <InputGroup>
                      <div className="formfieldMain">
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter Password*"
                          {...register("password", {
                            required: "New Password is required",
                            minLength: {
                              value: 8,
                              message:
                                "Password must be at least 8 characters long",
                            },
                            pattern: {
                              value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                              message:
                                "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                            },
                          })}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <FontAwesomeIcon
                          icon={iconOne}
                          className="eyeIcon"
                          onClick={() => togglePasswordVisibility("password")}
                        />
                      </div>
                    </InputGroup>
                    {/* {errors.password && (
                      <span className="text-danger">
                        {errors.password.message}
                      </span>
                    )} */}
                  </Form.Group>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section my-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Conform Password</Form.Label>
                    </div>
                    <InputGroup>
                      <div className="formfieldMain">
                        <Form.Control
                          type={showPasswordOne ? "text" : "password"}
                          placeholder="Re-Enter Password*"
                          {...register("re_password", {
                            required: "Re-Password is required",
                          })}
                          onChange={(e) => setPasswordAgain(e.target.value)}
                        />
                        <FontAwesomeIcon
                          icon={iconTwo}
                          className="eyeIcon"
                          onClick={() =>
                            togglePasswordVisibility("reenterPassword")
                          }
                        />
                      </div>
                    </InputGroup>
                    {password && (
                      <PasswordChecklist
                        rules={[
                          "minLength",
                          "specialChar",
                          "number",
                          "capital",
                          "match",
                        ]}
                        minLength={8}
                        value={password}
                        valueAgain={passwordAgain}
                        onChange={(isValid) => {}}
                        style={{
                          fontSize: "10px",
                          padding: "4px",
                          margin: "0",
                        }}
                      />
                    )}
                    {errors.re_password && (
                      <span className="text-danger">
                        {errors.re_password.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
